import { environment } from '@environments/environment';

/**
 * Причины, с которыми сервис уводит пользователя на портал единого входа:
 * коды совпадают с ответами API (403) и с текстами на портале.
 */
export type PortalReason = 'no-access' | 'no-rights' | 'blocked' | 'invalid-token';

const PORTAL_REASONS: readonly PortalReason[] = ['no-access', 'no-rights', 'blocked', 'invalid-token'];

/** Переход на портал: https://<портал>/?app=nok&reason=<причина>. */
export function redirectToPortal(reason: PortalReason): void {
    const url = new URL(environment.portalUrl);
    url.searchParams.set('app', 'nok');
    url.searchParams.set('reason', reason);
    window.location.replace(url.toString());
}

/** Причина для портала из тела ответа 403 `{ code, message }`; null — ошибка не про доступ к сервису. */
export function portalReasonForError(error: unknown): PortalReason | null {
    const code = (error as { code?: unknown } | null)?.code;
    return typeof code === 'string' && (PORTAL_REASONS as readonly string[]).includes(code)
        ? (code as PortalReason)
        : null;
}
